import React, { useState, useEffect, useRef } from "react";
import { IoIosSearch } from "react-icons/io";
import { LuPlus } from "react-icons/lu";
import { CiEdit } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { Edit } from "lucide-react";
import Pagination from "../Components/Pagination";
import axiosInstance from "../axiosinstance";
import { PiSortAscendingThin } from "react-icons/pi";

function ServiceMaster({ isSidebarExpanded }) {
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchVisible, setSearchVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSortPopup, setIsSortPopup] = useState(false);
  const containerRef = useRef();
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
  const ITEMS_PER_PAGE = 100;

  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState();
  const [totalRecords, setTotalRecords] = useState();
  const searchTimeoutRef = useRef(null);

  // const fetchServices = async (currentPage = 1) => {
  //   console.log("Fetching services for page:", currentPage);

  //   if (isNaN(currentPage) || currentPage <= 0) {
  //     console.error("Invalid page number:", currentPage);
  //     return;
  //   }

  //   try {
  //     const authKey = localStorage.getItem("authKey");
  //     if (!authKey) {
  //       setError("Authorization token is missing.");
  //       setLoading(false);
  //       return;
  //     }

  //     const response = await axios.get(`${API_URL}/api/get_service`, {
  //       headers: { Authorization: `Bearer ${authKey}` },
  //       params: { page: currentPage, per_page: ITEMS_PER_PAGE },
  //     });

  //     setServices(response.data.data);
  //     setTotalRecords(response.data.Total_records || 0);
  //     setLoading(false);
  //   } catch (err) {
  //     setError("Error fetching services data.");
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchServices(page); // ✅ Only pass `page`, `itemsPerPage` is already handled in `fetchServices`
  // }, [page, itemsPerPage]);

  const fetchServices = async (currentPage = 1, query = "") => {
    console.log("Fetching services for page:", currentPage, "Search:", query);
    setLoading(true);

    try {
      const response = await axiosInstance.get(
        query ? `/api/search_service_master` : `/api/get_service`,
        {
          params: {
            query: query || undefined,
            page: currentPage,
            per_page: ITEMS_PER_PAGE,
          },
        }
      );

      if (response.status === 200) {
        setServices(response.data.data || []);
        setTotalRecords(response.data.Total_records || 0);
      } else {
        setError("Failed to fetch services.");
      }
    } catch (err) {
      console.error("Error fetching services:", err);
      setError("Error fetching services. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchServices(page, searchQuery);
  }, [page, searchQuery]); // ✅ Fetch only when page OR searchQuery changes

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsSortPopup(false);
      }
    };

    // Only add the event listener when the popup is open
    if (isSortPopup) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Cleanup function to remove the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSortPopup]);

  const handleService = () => {
    navigate("/Service-Master-Form");
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedRecords = [...services].sort((a, b) => {
      let aValue = a[key];
      let bValue = b[key];

      if (key === "selling_cost" || key === "purchase_cost") {
        aValue = parseFloat(a[key]);
        bValue = parseFloat(b[key]);
      }

      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setSortConfig({ key, direction });
    setServices(sortedRecords);
  };

  const handleEdit = (service_id) => {
    navigate(`/edit-master-form/${service_id}`);
  };

  // const handleSearch = async (e) => {
  //   const query = e.target.value;
  //   setSearchQuery(query);

  //   if (query.trim() === "") {
  //     fetchServices();
  //   } else {
  //     try {
  //       setLoading(true);
  //       const authKey = localStorage.getItem("authKey");

  //       const response = await axios.get(
  //         `${API_URL}/api/search_service_master`,
  //         {
  //           params: { query },
  //           headers: { Authorization: `Bearer ${authKey}` },
  //         }
  //       );

  //       setServices(response.data.data || []);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching search results:", error.message);
  //       setLoading(false);
  //     }
  //   }
  // };

  const handleSearch = (e) => {
    const query = e.target.value.trim();
    setSearchQuery(query);
    setPage(1); // ✅ Reset to page 1 when searching

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      // ✅ Let useEffect handle API call instead of calling fetchServices manually
    }, 500);
  };

  const handlePaginationChange = (newPage) => {
    console.log("Pagination Change - Current Page:", newPage);
    setPage(newPage); // ✅ Let useEffect trigger the API call
  };

  const toggleSortPopup = (event) => {
    event.stopPropagation(); // Prevent event bubbling
    setIsSortPopup(!isSortPopup);
  };

  function formatNumbers(number) {
    if (number === null || number === undefined || isNaN(number)) return "N/A";

    return new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    }).format(number);
  }
  return (
    <>
      <div
        className={`table-container service-master-page ${isSidebarExpanded ? "expanded" : "collapsed"
          }`}
      >
        <div className="table-container-content service-master-content">
          {/* <div className="table-header">
            <div className="table-header-content">
              <h2 className="jost-bold">Service Master</h2>
              <div className="table-right-side">
                <div className="search-bar-container">
                  <input
                    type="text"
                    placeholder="Search ..."
                    className="search-bar"
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                  <IoIosSearch className="search-bar-icon" />
                </div>
                <div className="new-button" onClick={handleService}>
                  <span className="new-icon">
                    <LuPlus />
                  </span>
                  <span>New</span>
                </div>
                <button onClick={toggleSortPopup}>
                  <span className="action-icon custom-action-icon-size">
                    <PiSortAscendingThin />
                  </span>
                </button>
                {isSortPopup && (
                  <div className="sort-popup-container" ref={containerRef}>
                    <div className="sort-popup-header">
                      <span className="sort-title">Sort By</span>
                    </div>
                    <div className="sort-popup-content">
                      <button
                        className="sort-button sort-button-options"
                        onClick={() => handleSort("service_name")}
                      >
                        Service Name
                      </button>
                      <button
                        className="sort-button sort-button-options"
                        onClick={() => handleSort("purchase_cost")}
                      >
                        Purchase Cost
                      </button>
                      <button
                        className="sort-button sort-button-options"
                        onClick={() => handleSort("selling_cost")}
                      >
                        Selling Cost
                      </button>
                      <button
                        className="sort-button sort-button-options"
                        onClick={() => handleSort("gst_rate")}
                      >
                        GST Rate
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div> */}
          <div className="table-header">
  <div className="table-header-content">

    {/* LEFT SIDE */}
    <div className="table-left-side">
      <h2 className="jost-bold">Service Master</h2>
    </div>

    {/* RIGHT SIDE */}
    <div className="table-right-side">

      {/* Search */}
      <div className="search-bar-container">
        <input
          type="text"
          placeholder="Search ..."
          className="search-bar"
          value={searchQuery}
          onChange={handleSearch}
        />
        <IoIosSearch className="search-bar-icon" />
      </div>

      {/* New Button */}
      <div className="new-button" onClick={handleService}>
        <span className="new-icon">
          <LuPlus />
        </span>
        <span>New</span>
      </div>

      {/* Sort Button */}
      <button className="service-master-sort-button" onClick={toggleSortPopup}>
        <span className="action-icon custom-action-icon-size">
          <PiSortAscendingThin />
        </span>
      </button>

      {/* Sort Popup */}
      {isSortPopup && (
        <div className="sort-popup-container" ref={containerRef}>
          <div className="sort-popup-header">
            <span className="sort-title">Sort By</span>
          </div>

          <div className="sort-popup-content">
            <button
              className="sort-button sort-button-options"
              onClick={() => handleSort("service_name")}
            >
              Service Name
            </button>

            <button
              className="sort-button sort-button-options"
              onClick={() => handleSort("purchase_cost")}
            >
              Purchase Cost
            </button>

            <button
              className="sort-button sort-button-options"
              onClick={() => handleSort("selling_cost")}
            >
              Selling Cost
            </button>

            <button
              className="sort-button sort-button-options"
              onClick={() => handleSort("gst_rate")}
            >
              GST Rate
            </button>
          </div>
        </div>
      )}

    </div>
  </div>
</div>

          <div className="data-list-body service-master-data-body">
            <div className="data-list-scroll-body service-master-scroll-body">
              {/* <div className="data-list-table"> */}
                {loading ? (
                  <p>Loading...</p>
                ) : error ? (
                  <p>{error}</p>
                ) : services.length === 0 ? (
                  <p className="no-data-text">No records available.</p>
                ) : (
                  <table className="table multilevel-data df-txt-left service-master-table">
                    <thead className="sticky-header">
                      <tr className="table-row">
                        <th style={{ textAlign: 'center' }} className="se-no-column">Sr. No</th>
                        <th> <span style={{
                          textAlign: 'left',
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center'
                        }}>Service</span></th>
                        <th className="price-left-align">Purchase Cost</th>
                        <th className="price-left-align">Selling Cost</th>
                        <th>GST</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {services.map((service, index) => (
                        <tr key={service.service_id} className="hoverable-row">
                          <td className="center-align">{service.serial_number}</td>
                          <td>
                            {service.service_name
                              ? service.service_name.toUpperCase()
                              : "N/A"}
                          </td>
                          <td className="center-align price-left-align service-cost-cell service-purchase-cost">
                            {formatNumbers(service.purchase_cost)}
                          </td>
                          <td className="center-align price-left-align service-cost-cell service-selling-cost">
                            {formatNumbers(service.selling_cost)}
                          </td>
                          <td className="center-align service-gst-cell">{service.gst_rate}%</td>
                          <td className="service-action-cell">
                            <div className="action-btn">
                              <span className="action-icon">
                                <CiEdit
                                  onClick={() => handleEdit(service.service_id)}
                                  color="gray"
                                />
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              {/* </div> */}
            </div>
            <Pagination
              className="service-master-pagination"
              total={totalRecords}
              showPerPage={ITEMS_PER_PAGE}
              onPaginationChange={handlePaginationChange}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ServiceMaster;
